import React from 'react'
import './YouNeed.css'
import { Col, Container, Row } from 'react-bootstrap'
function YouNeed() {
    return (
        <>
            <section className='youneed_section'>
                <Container>
                    <div className='youneed_div'>

                        <Row>
                            <Col xxl={6} xl={6} lg={6}  >
                                <div className='youneed_text'>
                                    <p className='text motto'>OUR MOTTO</p>
                                    <h2 className='title'>Wherever You Need To Go We'll Take You There.</h2>
                                    <p className='text'>Whether it’s a quick trip across town or a special event, we’re here to get you there safely and on time. Our experienced drivers and clean, comfortable vehicles ensure a smooth and reliable ride every time. Choose us for all your transportation needs and experience the best in service and convenience!</p>
                                </div>
                            </Col>
                            <Col xxl={6} xl={6} lg={6} >
                                <div className='youneeedimgdiv'>
                                    <div className='youneedmain_imgdiv'>
                                        <img src={process.env.PUBLIC_URL + "/assets/images/Aboutus/onlinetaxi.png"} className="onlietaximg" />
                                    </div>
                                </div>
                            </Col>
                        </Row>

                    </div>
                </Container>
            </section>
        </>
    )
}

export default YouNeed